var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPortfolioBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_110_4926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2266 4.125V9.625C21.2266 9.98967 21.3795 10.3394 21.6518 10.5973C21.9241 10.8551 22.2933 11 22.6784 11H28.4856",
    stroke: "#0C6CDE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5823 28.875H11.0643C10.2942 28.875 9.55563 28.5853 9.01109 28.0695C8.46656 27.5538 8.16064 26.8543 8.16064 26.125V6.875C8.16064 6.14565 8.46656 5.44618 9.01109 4.93046C9.55563 4.41473 10.2942 4.125 11.0643 4.125H21.2269L28.486 11V26.125C28.486 26.8543 28.18 27.5538 27.6355 28.0695C27.091 28.5853 26.3524 28.875 25.5823 28.875Z",
    stroke: "#0C6CDE",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9678 9.625H15.4196",
    stroke: "#0C6CDE",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9678 17.875H22.6786",
    stroke: "#0C6CDE",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7749 23.375H22.6785",
    stroke: "#0C6CDE",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110_4926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.8434,
    height: 33,
    fill: "white",
    transform: "translate(0.901367)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPortfolioBlue);
export default __webpack_public_path__ + "static/media/Icon_Portfolio_Blue.72ac07eb095a8959a54417c21c9a0827.svg";
export { ForwardRef as ReactComponent };